import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useModal, Button, Card, CardBody, Checkbox, Heading, Flex, Input, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import Page from 'components/Layout/Page'
import PageHeader from 'components/PageHeader'
import addresses from 'config/constants/contracts'
import { getAddress } from 'utils/addressHelpers'
import useCreateToken from './hooks/useCreateToken'
import ConfirmModal from './components/ConfirmModal'


const Launch: React.FC = () => {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [symbol, setSymbol] = useState('')
  const [totalSupply, setTotalSupply] = useState('')
  const [rewardToken, setRewardToken] = useState('')
  const [minTokenBalanceForDividends, setMinTokenBalanceForDividends] = useState('')
  const [rewardFee, setRewardFee] = useState('')
  const [liquidityFee, setLiquidityFee] = useState('')
  const [marketingFee, setMarketingFee] = useState('')
  const [marketingWallet, setMarketingWallet] = useState('')
  const [antibot, setAntibot] = useState(false)
  const [babyToken, setBabyToken] = useState('')
  const [isCreating, setIsCreating] = useState(false)
  const { onCreateToken } = useCreateToken()

  const onDismiss = () => {
    setIsCreating(false);
  }

  const [onPresentConfirmModal] = useModal(<ConfirmModal address={babyToken} onDismiss={onDismiss} />)
  
  const handleCreateToken = async () => {
    /*
    string memory _name,
        string memory _symbol,
        uint256 _totalSupply,
        address[4] memory _addrs, // reward, router, marketing wallet, dividendTracker
        uint256[3] memory _feeSettings, // rewards, liquidity, marketing
        uint256 _minimumTokenBalanceForDividends,
        address _serviceFeeReceiver,
        uint256 _serviceFee
    */
    /*
      reward: 0x76F820E78EE033100459c6Cf412084669BeF6c1E
      router: 0xD99D1c33F9fC3444f8101754aBC46c52416550D1
      marketingWallet: 0xaEC25A9e0D64b3CafEb256C2942d00013ad6437c
    */
    //const babyTokenOrgAddress = "0xa8fe96ED450A4550b77200Be51abb8B839F23573" 
    const params = {
      // "implementation": babyTokenOrgAddress,
      "name": name,
      "symbol": symbol,
      "totalSupply": totalSupply,
      "addressAry":[
        rewardToken,
        getAddress(addresses.pancakeRouter),
        marketingWallet,
        '0xecdb0218f341d3C4af9d13d962cf64677065CC8E'
      ],
      "feeSettings": [ parseInt(rewardFee), parseInt(liquidityFee), parseInt(marketingFee)],
      "minTokenBalanceForDividends": parseInt(minTokenBalanceForDividends), 
      "serviceFeeReceiver": '0xaEC25A9e0D64b3CafEb256C2942d00013ad6437c',
      "serviceFee": 0
    }
    console.log("[GD], params=",  params)
    const res = await onCreateToken(params)
    if(res.status){
      console.log("[GD], babyAddress = ", res.babyToken);
      setBabyToken(res.babyToken)
      setIsCreating(true)
      console.log("[GD], isCreating = ", isCreating)
    }
  }
  useEffect(() => {
    if(isCreating){
      onPresentConfirmModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCreating])

  return (
    <>
      <Page>
        <PageHeader>
          <Flex justifyContent="space-between" flexDirection={['column', null, null, 'row']}>
            <Flex flex="1" flexDirection="column" mr={['8px', 0]}>
              <Heading as="h1" scale="xxl" color="textSubtle" mb="24px">
                {t('Create Token')}
              </Heading>
              <Heading scale="lg" color="textSubtle">
                {t(`User can create any BabyToken according to their requirements here !!!`)}
              </Heading>
              <Heading scale="lg" color="textSubtle">
                {t(`User will consume 0.2BNB for creating the token`)}
              </Heading>
            </Flex>
          </Flex>
        </PageHeader>
        <Card mt="30px">
          <CardBody>
            <Flex flexDirection="column" justifyContent="center" mb="20px">
              <Text>{t('Name')}</Text>
              <Input placeholder="Ex: Binance"
                value={name}
                onChange={(e) => setName(e.target.value)}
                />
            </Flex>
            <Flex flexDirection="column" justifyContent="center" mb="20px">
              <Text>{t('Symbol')}</Text>
              <Input placeholder="Ex: BNB"
                value={symbol}
                onChange={(e)=>setSymbol(e.target.value)}
              />
            </Flex>
            <Flex flexDirection="column" justifyContent="center" mb="20px">
              <Text>{t('Total supply')}</Text>
              <Input type="number" placeholder="Ex: 100000000000"
                value={totalSupply}
                onChange={(e)=>setTotalSupply(e.target.value)}
              />
            </Flex>
            <Flex flexDirection="row" justifyContent="space-between" mb="20px" width="100%">
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Reward token')}</Text>
                <Input placeholder="Ex: 0x"
                  value={rewardToken}
                  onChange={(e)=>setRewardToken(e.target.value)}
                />
              </Flex>
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Minimum token balance for dividens')}</Text>
                <Input placeholder="Ex: 1000000000"
                  value={minTokenBalanceForDividends}
                  onChange={(e)=>setMinTokenBalanceForDividends(e.target.value)}
                />
              </Flex>
            </Flex>
            <Flex flexDirection="row" justifyContent="space-between" mb="20px" width="100%">
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Token reward fee (%)')}</Text>
                <Input type="number" placeholder="1 - 100"
                  value={rewardFee}
                  onChange={(e)=>setRewardFee(e.target.value)}
                />
              </Flex>
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Auto add liquidity (%)')}</Text>
                <Input type="number" placeholder="1 - 100"
                  value={liquidityFee}
                  onChange={(e)=>setLiquidityFee(e.target.value)}
                />
              </Flex>
            </Flex>
            <Flex flexDirection="row" justifyContent="space-between" mb="20px" width="100%">
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Marketing fee (%)')}</Text>
                <Input type="number" placeholder="1 - 100"
                  value={marketingFee}
                  onChange={(e)=>setMarketingFee(e.target.value)}
                />
              </Flex>
              <Flex flexDirection="column" justifyContent="center" width="49%">
                <Text>{t('Marketing wallet')}</Text>
                <Input placeholder="Ex: 0x"
                  value={marketingWallet}
                  onChange={(e)=>setMarketingWallet(e.target.value)}
                />
              </Flex>
            </Flex>
            <Flex flexDirection="row" justifyContent="start" mb="20px" width="100%" alignItems="center" alignContent="center">
              <Checkbox
                name="confirmed"
                type="checkbox"
                checked={antibot}
                onChange={() => setAntibot(!antibot)}
                scale="sm"
              />
              <Text ml="10px" style={{ userSelect: 'none' }}>
                {t('Implement Anti-Bot System?')}
              </Text>
            </Flex>
            <Flex justifyContent="center" width="100%" mt="30px">
              <Button onClick={handleCreateToken}>{t('Create Token')}</Button>
            </Flex>
          </CardBody>
        </Card>
      </Page>
    </>
  )
}

export default Launch
